import { render } from "./InventoryCategories.vue?vue&type=template&id=2350d979&scoped=true"
import script from "./InventoryCategories.vue?vue&type=script&lang=js"
export * from "./InventoryCategories.vue?vue&type=script&lang=js"

import "./InventoryCategories.vue?vue&type=style&index=0&id=2350d979&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2350d979"]])

export default __exports__